@if (step === 'contact-sales') {
  <app-availability-contact-sales (selected)="onComplete()"></app-availability-contact-sales>
}
@if (initialized) {
  <div>
    @if (step === 'select') {
      <app-select-availability
        [selectedAvailability]="model.availability"
        [availabilityLevels]="model.availabilityLevels"
        (premiumSelected)="onPremiumSelected()"
        (standardSelected)="onStandardSelected()"
        (back)="onAvailabilityBack()"
      ></app-select-availability>
    }
    @if (step === 'downgrade') {
      <app-warning-confirm-box
        [hideCancelBtn]="true"
        [confirmHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
        [confirmDetailsHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
        [confirmDetailsText]="'availability_downgrade_premium_confirm_text' | i18next"
        [confirmBtn]="'availability_downgrade_premium_confirm_btn_partner' | i18next:{email: model.contact.email}"
        [footerCancelBtnText]="'availability_downgrade_premium_confirm_btn_cancel' | i18next"
        (back)="onDowngradeBack()"
        (confirm)="onDowngradeSelected()"
      ></app-warning-confirm-box>
    }
    @if (step === 'contact') {
      <app-select-invoice-contact
        [customer]="model.customer"
        [subscription]="model.subscription"
        (back)="onContactBack()"
        [historyBack]="false"
        (selected)="onContact($event)">
      </app-select-invoice-contact>
    }
    @if (step === 'address') {
      <app-invoice-address
        (next)="onInvoiceNext($event)"
        (backEvent)="onInvoiceAddressBack()"
        [company]="model.company"
        [historyBack]="false">
      </app-invoice-address>
    }
    @if (step === 'payment') {
      <app-payment-method
        (next)="onPaymentMethod($event)"
        (backEvent)="onPaymentMethodBack()"
        [onlyEmit]="true"
        [historyBack]="false"
        [paymentMethod]="paymentMethod">
      </app-payment-method>
    }
    @if (step === 'checkout') {
      <app-checkout-one-summary
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        [historyBack]="false"
        (buy)="onBuy()">
      </app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-partner-upgrade-offer-sent
        (next)="onComplete()"
        [customerEmail]="model.saleOrder.contact.email">
      </app-partner-upgrade-offer-sent>
    }
  </div>
}